/* @flow */
// typecheck: ignore file
import React from 'react';
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import Statistic from 'admin/components/Statistic.jsx';

import './styles/SchoolStatistics.scss';

type Props = {
  organizationId: number,
  data: {
    loading: boolean,
    organizations?: [{
      statistics: {
        teacher_count: number,
        message_count: number,
        subscriber_count: number,
      },
    }]
  }
}

function SchoolStatistics(props: Props) {
  const { loading, organizations } = props.data;

  if (loading || !organizations) {
    return null;
  }

  const { statistics } = organizations[0];

  return (
    <div className="SchoolStatistics">
      <Statistic nameColor="thunder" name="Teachers" value={statistics.teacher_count} size="xxlarge" />
      <Statistic nameColor="thunder" name="Participants" value={statistics.subscriber_count} size="xxlarge" />
      <Statistic nameColor="thunder" name="Announcements (past 90 days)" value={statistics.message_count} size="xxlarge" />
    </div>
  );
}


const withOrganizationStatistics = graphql(gql`
  query($organizationId: Int) {
    organizations(ids: [$organizationId]) {
      id
      statistics {
        teacher_count
        message_count
        subscriber_count
      }
    }
  }
  `,
  {
    options: ({ organizationId }) => ({
      variables: { organizationId: [organizationId] },
    }),
  }
);

export { SchoolStatistics };
export default withOrganizationStatistics(SchoolStatistics);



// WEBPACK FOOTER //
// ./src/admin/components/SchoolStatistics.jsx